<template>
  <b-row>
    <b-col cols="8" class="container">
      <b-row>
        <LeftTab
          :complaintData="complaintData"
          @onComplaintBtnCancelClicked="onComplaintBtnCancelClicked"


          :IsAllowDelete_PersonDataDigital="false"
          :IsReadOnly_PersonDataDigital="false"
          :personals="personals"
          :attorneys="attorneys"
          @onPersonDigitalEditClicked="onPersonDigitalEditClicked"

          :IsEdit_CompanyDetail="false"
          :IsDeleteAble_CompanyDetail="false"
          :IsReadOnly_CompanyDetail="true"


          :IsEdit_CompanySearch="true"
          :complainantCompany="complainantCompany"
          @onBtnCompanySearchClicked="onBtnCompanySearchClicked"
          @onBtnCompanySearchDeleteClicked="onBtnCompanySearchDeleteClicked"
          @company-digital-modal-clicked="companyModalClicked"

          :IsReadOnly_ComplaintDetail="false"
          :complaintDetail="complaintDetail"
          :complaintCatagoryDetail="complaintCatagoryDetail"
          :complaintDetailMultiSelect="complaintDetailMultiSelect"
          :company="complaintData"
          @checkboxChanged="checkboxChanged"

          :IsEdit_TabAttachFiles="true"
          :attachFiles="attachFiles"
          :attachFileDate="attachFileDate"
          :attachFilesType2="attachFilesType2"
          :attachFileDateType2="attachFileDateType2"
          :fileFormstatusModel="fileFormstatusModel"
          :fileFormstatusModelDates="fileFormstatusModelDates"
:fileFormstatusType3Model="fileFormstatusType3Model"
          :fileFormstatusType3ModelDates="fileFormstatusType3ModelDates"
:fileFormstatusType4Model="fileFormstatusType4Model"
          :fileFormstatusType4ModelDates="fileFormstatusType4ModelDates"
          @onAttachFileUploaded="onAttachFileUploaded"
          @onAttachFileDelete="onAttachFileDelete"

          :IsEditData="true"
        />
      </b-row>
    </b-col>
    <RightTab
      :complaintId="this.$route.query.id"
      :redirectComponentName="'RequestConfirm'"
      :backComponentName="'LawLeaderDept'"
      :copyComponentName="'LawLeaderDeptManage'"
      :IsUse_Tab3="true"
    />

    <ModalDigitalId
      ref="modalDigitalIdComponent"
      :userId="currentUserIdModal"
      @handle-success="onModalDigitalIdSuccess"
    />

    <ModalCompany
      ref="modalCompanyComponent"
      :company="currentCompanyModal"
      @handle-submit="onBtnCompanySearchSubmit"
    />

    <ModalDigitalIdCompany
      ref="modalDigitalIdCompanyComponent"
      :compId="currentCompIdModal"
      @handle-success="onModalDigitalIdCompanySuccess"
    />

  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";

import Company from "../components/Company.vue";
import ModalPersonal from "./components/ModalPersonal.vue";
import ComplainDetail from "../components/ComplainDetail.vue";
import BasicDetail from "../components/BasicDetail.vue";
import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import CompanyDetail from "../components/CompanyDetail.vue";
import CompanySearch from "../components/CompanySearch.vue";
import RightTab from "../components/RightTabAction.vue";
import TabAttachFiles from "../components/TabAttachFiles.vue";
import TabDocumentTrackingDetail from "../components/TabDocumentTrackingDetail.vue";

import ModalDigitalIdCompany from "@/views/Complaint/components/DigitalIdCompanyModal.vue";

import PersonDataDigital from "../components/PersonDataDigital.vue";
import ModalDigitalId from "../components/DigitalIdUserModal.vue";
import ModalCompany from "./../screening/components/ModalCompany.vue";
import ComplaintDetail from "./../screening/components/ComplaintDetail.vue";
import * as viewStore from "@/store/api/screening/screeningManage.js";
import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as userStore from "@/store/api/user/index.js";
import * as companyStore from "@/store/api/company/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import LeftTab from "../components/LeftTabAction.vue";
export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    Company,
    BasicDetail,
    BCardActions,
    RightTab,
    TabAttachFiles,
    ModalPersonal,
    ComplainDetail,
    viewStore,
    complaintStore,
    ModalDigitalId,
    ModalCompany,
    PersonDataDigital,
    CompanyDetail,
    CompanySearch,
    ComplaintDetail,
    userStore,
    TabDocumentTrackingDetail,
    LeftTab,
    ModalDigitalIdCompany,
  },
  data() {
    
    return {
      personals: [],
      attorneys: [],
      complainantCompany: [],
      currentUserIdModal: "",
      currentCompIdModal: "",
      currentCompanyModal: {},
      complaintData: {},
      complaintDetail: [],
      complaintDetailMultiSelect: [],
      masterIdList: [],
      complainId: null,
      attachFiles: [],
      attachFileDate: [],
      complaintCatagoryDetail: [],
      attachFilesType2: [],
      attachFileDateType2: [],
        fileFormstatusModel: [],
      fileFormstatusModelDates: [],
      fileFormstatusType3Model: [],
      fileFormstatusType3ModelDates: [],
      fileFormstatusType4Model: [],
      fileFormstatusType4ModelDates: [],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
      const id = 1;
    } else {
      const qid = this.$route.query.id;
      this.getComplaintById(qid);
    }
  },
  methods: {
    getComplaintById(id) {
      const _this = this;
      //console.log('userData.userId', userData.userId())
      //console.log('userData.departmentId', userData.departmentId())
      complaintStore
        .getComplaintById(id)
        .then(function(response) {
          // handle success

          console.log("GetComplaintById", response);

          _this.personals = response.data.data.personals;
          _this.attorneys = response.data.data.attorneys;
          _this.complaintData = response.data.data.complaintModel;
          _this.complainantCompany = response.data.data.complainantCompany;
          _this.attachFiles = response.data.data.attachFiles;
          _this.attachFileDate = response.data.data.attachFileDate;
          _this.attachFilesType2 = response.data.data.attachFilesType2;
          _this.attachFileDateType2 = response.data.data.attachFileDateType2;
          _this.fileFormstatusModel = response.data.data.fileFormstatusModel;
          _this.fileFormstatusModelDates = response.data.data.fileFormstatusModelDates;
_this.fileFormstatusType3Model = response.data.data.fileFormstatusType3Model;
          _this.fileFormstatusType3ModelDates = response.data.data.fileFormstatusType3ModelDates;
_this.fileFormstatusType4Model = response.data.data.fileFormstatusType4Model;
          _this.fileFormstatusType4ModelDates = response.data.data.fileFormstatusType4ModelDates;
          _this.complaintDetail = response.data.data.complaintDetail;
          _this.complaintDetailMultiSelect =
            response.data.data.complaintDetailMultiSelect;
          _this.complaintCatagoryDetail = response.data.data.complaintCatagoryDetail;

          

          _this.complaintDetail.forEach((value, index) => {
            value.tmMasterList.forEach((value2, index2) => {
              if (value2.checked === true) {
                _this.masterIdList.push(value2.masterId);
              }
            });
          });

          const filterAttach = _this.attachFiles.filter((value) => {
            return value.createDateStr === _this.attachFileDate[0]
          })

          console.log("_this.attachFileDate", _this.attachFileDate, filterAttach);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onPersonDigitalEditClicked(userId) {
      this.currentUserIdModal = userId;
      this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].show();
    },
    onModalDigitalIdSuccess(id) {
      const _this = this;
      // need to get user id to update to view
      const currentUserId = id;
      this.currentUserIdModal = "";

      userStore
        .getById(currentUserId)
        .then(function(response) {
          // handle success
          console.log("userStore.getById", response);
          if (response.data.data !== null) {
            const person = response.data.data;

            const perIndex = _this.personals?.findIndex(function(value) {
              return value.userId === currentUserId;
            });

            const atIndex = _this.attorneys?.find(function(value) {
              return value.userId === currentUserId;
            });

            console.log("perIndex", perIndex, "atIndex", atIndex);

            if (perIndex >= 0 && perIndex != undefined) {
              _this.$set(_this.personals, perIndex, person);
            } else if (atIndex >= 0 && atIndex != undefined) {
              _this.$set(_this.attorneys, atIndex, person);
            } else {
              console.log(
                "personal",
                _this.personals,
                "attorneys",
                _this.attorneys
              );
              if (_this.modalMode === "personal") {
                //if (_this.personals === undefined) _this.personals = []
                _this.$set(_this.personals, _this.personals.length, person);
                //_this.personals.push(person)
              } else {
                //if (_this.attorneys === undefined) _this.attorneys = []
                _this.$set(_this.attorneys, _this.attorneys.length, person);
              }
              //console.log('personals', _this.personals, 'attorneys', _this.attorneys)
            }
          }

          //_this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdComponent.$refs["modal-digital-id"].hide();
        });
    },
    companyModalClicked(id) {
      this.currentCompIdModal = id;
      this.$refs.modalDigitalIdCompanyComponent.$refs[
        "modal-digital-id-company"
      ].show();
    },
    onModalDigitalIdCompanySuccess(id) {
      let _this = this;
      console.log("this", this.complainantCompany);
      console.log("onModalDigitalIdCompanySuccess", id);
      // need to get comp id to update to view
      const currentCompId = id;
      this.currentCompIdModal = "";

      companyStore
        .getById(currentCompId)
        .then((response) => {
          const company = {
            compId: response.data.data.compId,
            companyDetail: response.data.data.juristicNameTh,
            address: {},
          };

          if (
            response.data.data.juristicBranchTh !== null &&
            response.data.data.juristicBranchTh !== undefined
          ) {
            company.companyDetail = company.companyDetail.juristicBranchTh;
          }

          console.log('company', company)

          companyStore
            .getAddressDetail(company.compId)
            .then((response2) => {
              company.address = response2.data.data;

              const compIndex = _this.complainantCompany?.findIndex(function(
                value
              ) {
                return value.compId === currentCompId;
              });

              if (compIndex >= 0 && compIndex != undefined) {
                _this.$set(_this.complainantCompany, compIndex, company);
              } else {
                _this.$set(
                  _this.complainantCompany,
                  _this.complainantCompany.length,
                  company
                );
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          _this.$refs.modalDigitalIdCompanyComponent.$refs["modal-digital-id-company"].hide();
        });
    },
    onBtnCompanySearchClicked(companyObj) {
      this.currentCompanyModal = companyObj;
      this.$refs.modalCompanyComponent.$refs["modal-company"].show();
    },
    onBtnCompanySearchDeleteClicked(companyObj) {

      var filteredAry = this.complainantCompany.filter(
        (o) => o.compId != companyObj.compId
      );

      this.complainantCompany = filteredAry;
    },
    onBtnCompanySearchSubmit() {
      const _this = this;
      this.$refs.modalCompanyComponent.$refs["modal-company"].hide();

      const index = this.complainantCompany?.findIndex(function(value) {
        return value.compId === _this.currentCompanyModal.compId;
      });

      if (index >= 0) {
        _this.$set(_this.complainantCompany, index, _this.currentCompanyModal);
      } else {
        _this.$set(
          _this.complainantCompany,
          _this.complainantCompany.length,
          _this.currentCompanyModal
        );
      }
    },
    onComplaintBtnCancelClicked() {
      window.open(this.$router.resolve({ name: "LawLeaderDept" }).href, "_self");
    },
    onComplaintBtnSubmitClicked() {
      const _this = this;

      this.$swal({
        title: "ยืนยันการบันทึกข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const data = {
            complaintModel: this.complaintData,
            personals: this.personals,
            attorneys: this.attorneys,
            attachFiles: this.attachFiles,
            complainantCompany: this.complainantCompany,
            userId: userData.userId(),
            complaintDetail: this.complaintDetail,
            complaintDetailMultiSelect: this.complaintDetailMultiSelect,
          };

          complaintStore
            .updateComplaint(data)
            .then((response) => {
              console.log("response", response);

              _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                variant: "success",
                solid: false,
              });

              // window.open(
              //   this.$router.resolve({ name: "screening" }).href,
              //   "_self"
              // );

              this.$router.go(this.$router.currentRoute);
            })
            .catch((error) => {
              console.log("err", error);
            });

          //window.open(this.$router.resolve({ name: "screening" }).href, "_self");
        }
      });
    },
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    checkboxChanged(obj) {
      //console.log("obj", obj);
      if (obj.checked) {
        this.masterIdList.push(obj.masterId);
      } else {
        //uncheck
        this.masterIdList = this.masterIdList.filter((o) => {
          return o != obj.masterId;
        });

        //remove check ที่ masterTypeIdถัดๆไปทั้งหมด เมื่อมีการ uncheck ข้อมูล

        var notInside = [];
        //get remove list
        this.complaintDetail.forEach((o) => {
          if (obj.masterTypeId < o.masterTypeId) {
            o.tmMasterList.forEach((o2) => {
              notInside.push(o2.masterId);
            });
          }
        });

        //console.log("notInside:", notInside);
        this.masterIdList = this.masterIdList.filter((o) => {
          return !notInside.includes(o);
        });
        //end check
      }

      console.log("masterIdList:", this.masterIdList);

      var self = this;

      complaintStore
        .GetMasterTypeAll(this.masterIdList)
        .then(function(response) {
          console.log("response:", response);
          var dataList = response.data.data; //list รายการทั้งหมด
          //self.$refs.Step3Ref.refreshPage()

          //แสดงรายการ checkbox
          self.complaintDetail.forEach((o) => {
            o.tmMasterList = dataList.filter((o2) => {
              return o2.masterTypeId == o.masterTypeId;
            });
          });

          //ใส่ค่า check true
          self.complaintDetail.forEach((o) => {
            o.tmMasterList.forEach((o2) => {
              if (self.masterIdList.includes(o2.masterId)) {
                o2.checked = true;
              }
            });
          });
          self.$refs.Step3Ref.refreshPage();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {});
      //console.log("checkboxChangeRoot: ", obj);
    },
  },
};
</script>

<style lang="scss"></style>
